// AllyPanel: the open chat window. Pure composition of sub-parts.
// All copy is passed via props (no defaults).

import { X as XIcon } from 'lucide-react';
import { AllyMessageList } from './AllyMessageList';
import { AllySuggestions } from './AllySuggestions';
import { AllyInput } from './AllyInput';
import type { AllyMessage } from '@lib/hooks/useAlly';

export interface AllyPanelCopy {
  triggerLabel: string;
  panelLabel: string;
  panelSubtitle: string;
  closeLabel: string;
  inputPlaceholder: string;
  messageLabel: string;
  sendLabel: string;
}

export interface AllyPanelProps {
  messages: ReadonlyArray<AllyMessage>;
  busy: boolean;
  suggestions: ReadonlyArray<string>;
  onSend: (q: string) => void;
  onClose: () => void;
  copy: AllyPanelCopy;
  avatarSrc?: string;
}

export function AllyPanel({
  messages,
  busy,
  suggestions,
  onSend,
  onClose,
  copy,
  avatarSrc = '/assets/alison-avatar.png',
}: AllyPanelProps) {
  const showSuggestions = messages.length <= 1 && !busy;
  const dialogLabel = `${copy.triggerLabel}`;

  return (
    <div className="ally__panel" role="dialog" aria-label={dialogLabel}>
      <div className="ally__head">
        <div className="av">
          <div className="ring" />
          <img src={avatarSrc} alt="" />
        </div>
        <div className="who">
          <b>{copy.panelLabel}</b>
          <span><span className="live" />{copy.panelSubtitle}</span>
        </div>
        <button className="x" onClick={onClose} aria-label={copy.closeLabel} type="button">
          <XIcon size={18} />
        </button>
      </div>

      <AllyMessageList messages={messages} busy={busy} />

      {showSuggestions && (
        <AllySuggestions suggestions={suggestions} onPick={onSend} disabled={busy} />
      )}

      <AllyInput
        onSend={onSend}
        placeholder={copy.inputPlaceholder}
        messageLabel={copy.messageLabel}
        sendLabel={copy.sendLabel}
        disabled={busy}
      />
    </div>
  );
}
